import React from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../assests/ArServicesImg/image.svg";

import "./WhyIOTSection.css";

const WhyIOTSection: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  // Define content based on path
  const contentByPath: Record<
    string,
    { heading: string; items: { title: string; desc: string }[] }
  > = {
    "/IOT-services": {
      heading: "Why Choose Xyloite For IOT & Robotics? ",
      items: [
        { title: "Innovation at Scale", desc: "Cutting-edge IoT and robotics solutions tailored to your business. " },
        { title: "Seamless Integration", desc: "Connect devices, AI, and robots into unified, smart ecosystems. ." },
        { title: "Scalable & Secure", desc: "Connect devices, AI, and robots into unified, smart ecosystems. " },
        { title: "End-to-End Service", desc: "From concept and prototyping to deployment, integration, and support. " },
      ],
    },
    "/Custom-Software": {
      heading: "Why Choose Xyloite For Custom Software?",
      items: [
        { title: "Cross-Platform Expertise", desc: "Web, mobile, and gaming platforms covered end-to-end." },
        { title: "Scalable & Secure", desc: "Solutions built for growth, reliability, and enterprise-grade security." },
        { title: "Creative + Technical Excellence", desc: "A perfect blend of design innovation and engineering precision." },
        { title: "Agile Delivery", desc: "Iterative development ensures faster time-to-market and continuous improvement." },
      ],
    },
        "/AI-ML-Solution": {
      heading: "Why Choose Xyloite For AI & ML Solution?",
      items: [
        { title: "Tailored AI Solutions", desc: "Custom models and AI agents built for your business objectives." },
        { title: "End-to-End Expertise", desc: "From data preprocessing and model development to deployment and monitoring." },
        { title: "Scalable & Secure", desc: "Enterprise-ready AI systems built to grow with your organization." },
        { title: "AI + Business Insight", desc: "Focused on creating measurable value, not just technical" },
      ],
    },
            "/ar/vr-services": {
      heading: "Why Choose Xyloite For AR/VR Solution? ",
      items: [
        { title: "Industry Expertise", desc: "Experience across retail, real estate, healthcare, education, and more. " },
        { title: "End-to-End Service ", desc: "From concept to deployment and post-launch support. " },
        { title: "Cutting-Edge Tech Stack", desc: "Unity, Unreal Engine, ARKit, ARCore, WebXR, and 3D design tools. " },
        { title: "Enterprise-Ready", desc: "Secure, scalable solutions that grow with your business. " },
      ],
    },
            "/cloud-services": {
      heading: "Why Choose Xyloite For Cloud Solution? ",
      items: [
        { title: "AI-Driven Insights", desc: "Smarter monitoring, forecasting & optimization.  " },
        { title: "Custom Dashboards  ", desc: "Built for your cloud, your KPIs, your visibility. " },
        { title: "Multi-Cloud Expertise", desc: " Deep knowledge of AWS, Azure, and GCP.  " },
        { title: "Proven Results", desc: "Cost reductions, efficiency gains, and measurable ROI. " },
      ],
    },
            "/Data-Management": {
      heading: "Why Choose Xyloite For Data Management ?  ",
      items: [
        { title: "Cloud-Native & Multi-Cloud  Expertise", desc: "AWS, Azure, and GCP.  " },
        { title: "Scalable Architecture", desc: "From startups to enterprises, we grow with you. " },
        { title: "AI-Powered Automation", desc: " Smart anomaly detection & predictive monitoring. " },
        { title: "End-to-End Security", desc: "Encryption, monitoring, and compliance-first approach.  " },
      ],
    },
  };

  // Use the content for the current path, or default to IoT
  const currentContent = contentByPath[path] || contentByPath["/iot"];

  return (
    <div className="container pt-5 pb-5">
      <h2 className="text-center mb-5 why-h2">{currentContent?.heading}</h2>

      <div className="row justify-content-center align-items-stretch text-white gx-4 gy-4 why-cards">
        {/* Left Column */}
        <div className="col-12 col-md-4 d-flex flex-column gap-3 p-0 why-card">
          {currentContent?.items.slice(0, 2).map((item, idx) => (
            <div key={idx} className={`why-card-box p-2 rounded shadow-sm text-start bg-${idx}`}>
              <h5 className="why-h5">{item.title}</h5>
              <p className="m-0 why-p">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Center Logo */}
        <div className="col-12 col-md-2 d-none d-lg-flex justify-content-center align-items-center p-0">
          <div className="logo-bg bg-light rounded">
            <img src={logo} alt="Xyloite Logo" className="img-fluid" />
          </div>
        </div>

        {/* Right Column */}
        <div className="col-12 col-md-4 d-flex flex-column gap-3 p-0 why-card">
          {currentContent?.items.slice(2, 4).map((item, idx) => (
            <div key={idx} className={`why-card-box p-2 rounded shadow-sm text-start bg-${idx + 2}`}>
              <h5 className="why-h5">{item.title}</h5>
              <p className="m-0 why-p">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyIOTSection;
